import { Theme } from '@mui/material';


const Input = (theme: Theme) => {
  return {
  };
};

export default Input;
